export { propertyGridControlDecorator } from './property-grid-control-decorator';
